import { Navigate, Outlet } from "react-router-dom"

import useGetUserRoles from "@/hooks/useGetUserRoles"
import { PATHS } from "@/routing/paths"

export const GuruWall = () => {
  const { hasRoleGuru } = useGetUserRoles()

  if (hasRoleGuru()) {
    return <Outlet />
  }

  return <Navigate to={PATHS.DASHBOARD} replace />
}
